import { h, Component } from "preact";
import IconFileSearch from "../../common/components/icons/IconFileSearch";
import { RELATED_NEWS_VIEW } from "../constants/relatedNewsView";
import AdaptativeDate from "../../common/components/AdaptativeDate";
class CalendarPosts extends Component {
    constructor(props) {
        super(props);
    }

    renderItemFetching() {
        return (
            <aside class="fxs_entriesList" id="renderItemFetching">
                <ol>
                    <li>
                        <div class="fxs_squareImage fxs_squareImage_s fxs_c_news_fake_image"></div>
                        <article class="fxs_entriesList_article_with_image ">
                            <div class="fxs_c_news_fake_line"></div>
                            <div class="fxs_c_news_fake_line"></div>
                            <div class="fxs_c_news_fake_meta"></div>
                        </article>
                    </li>
                    <li>
                        <div class="fxs_squareImage fxs_squareImage_s fxs_c_news_fake_image"></div>
                        <article class="fxs_entriesList_article_with_image ">
                            <div class="fxs_c_news_fake_line"></div>
                            <div class="fxs_c_news_fake_line"></div>
                            <div class="fxs_c_news_fake_meta"></div>
                        </article>
                    </li>
                </ol>
            </aside>
        );
    }

    renderFetching(view, wrapperClass, RelatedNewsTranslation) {
        return view === RELATED_NEWS_VIEW.View_Grid ? (
            <div>
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                <div class={wrapperClass}>{this.renderItemFetching()}</div>
                <div class={wrapperClass}>{this.renderItemFetching()}</div>
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Half ? (
            <div>
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                {this.renderItemFetching()}
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Mobile ? (
            <div class={wrapperClass}>
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                {this.renderItemFetching()}
            </div>
        ) : (
            <aside class="fxs_entriesList">
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                {this.renderItemFetching()}
            </aside>
        );
    }

    renderError(view, ErrorTranslation, wrapperClass, RelatedNewsTranslation) {
        return view === RELATED_NEWS_VIEW.View_Grid ? (
            <div class={wrapperClass} id="renderError">
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                <div class="fxs_c_news_error_wrapper">
                    <IconFileSearch />
                    <p class="fxs_txt_size_nano">{ErrorTranslation}</p>
                </div>
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Half ? (
            <div id="renderError">
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                <div class="fxs_c_news_error_wrapper">
                    <IconFileSearch />
                    <p class="fxs_txt_size_nano">{ErrorTranslation}</p>
                </div>
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Mobile ? (
            <div class={wrapperClass} id="renderError">
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                <div class="fxs_c_news_error_wrapper">
                    <IconFileSearch />
                    <p class="fxs_txt_size_nano">{ErrorTranslation}</p>
                </div>
            </div>
        ) : (
            <aside class="fxs_entriesList" id="renderError">
                <h3 class="fxs_headline_small">{RelatedNewsTranslation}</h3>
                <div class="fxs_c_news_error_wrapper">
                    <IconFileSearch />
                    <p class="fxs_txt_size_nano">{ErrorTranslation}</p>
                </div>
            </aside>
        );
    }

    renderItem(item, ByAuthorTranslation, culture, dateNow, customClassnameDict, customPostUrl) {
        customPostUrl = customPostUrl !== undefined ? customPostUrl.replace("{postId}",item.Id): customPostUrl;
        return (
            item && (
                <li>
                    <div className={`fxs_squareImage ${customClassnameDict['fxs_image'] || ' fxs_squareImage_s'}`}>
                        <img
                            class="lazyloaded"
                            data-src={item.Image.Url_Small}
                            src={item.Image.Url_Small}
                        />
                    </div>
                    <article class="fxs_entriesList_article_with_image ">
                        <h3 class={`${customClassnameDict['fxs_entryHeadline'] || ' fxs_headline_tiny'}`}>
                            <a
                                href={customPostUrl || item.Url}
                                title={item.Title}
                                target="_blank"
                            >
                                {item.Title}
                            </a>
                        </h3>
                        <address class="fxs_entry_metaInfo">
                            <span class="fxs_article_author">
                                <span>{ByAuthorTranslation} </span>
                                <span> </span>
                                <span class="fxs_txt_dark_4_clr">
                                    {item.Author.Name}
                                </span>
                            </span>
                            <span> | </span>
                            <time pubdate="" datetime="">
                                <AdaptativeDate
                                    currentDate = {item.PublicationDate}
                                    dateNow = {dateNow}
                                    culture = {culture}
                                ></AdaptativeDate>
                            </time>
                        </address>
                    </article>
                </li>
            )
        );
    }

    renderNews(
        view,
        wrapperClass,
        posts,
        RelatedNewsTranslation,
        ByAuthorTranslation,
        culture,
        customClassnameDict,
        customPostUrl
    ) {
        customClassnameDict = customClassnameDict || {};
        const dateNow = Date.now();
        return view === RELATED_NEWS_VIEW.View_Half ? (
            <div class={wrapperClass}>
                <h3 className={`${customClassnameDict['fxs_subtitle'] || ' fxs_headline_small'}`}>{RelatedNewsTranslation}</h3>
                <aside class="fxs_entriesList">
                    <ol>
                        {posts &&
                            this.renderItem(
                                posts[0],
                                ByAuthorTranslation,
                                culture,
                                dateNow,
                                customClassnameDict,
                                customPostUrl
                            )}
                        {posts &&
                            this.renderItem(
                                posts[1],
                                ByAuthorTranslation,
                                culture,
                                dateNow,
                                customClassnameDict,
                                customPostUrl
                            )}
                    </ol>
                </aside>
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Grid ? (
            <div>
                <h3 className={`${customClassnameDict['fxs_subtitle'] || ' fxs_headline_small'}`}>{RelatedNewsTranslation}</h3>
                <div>
                    <div class={wrapperClass}>
                        <aside class="fxs_entriesList">
                            <ol>
                                {posts &&
                                    this.renderItem(
                                        posts[0],
                                        ByAuthorTranslation,
                                        culture,
                                        dateNow,
                                        customClassnameDict,
                                        customPostUrl
                                    )}
                                {posts &&
                                    this.renderItem(
                                        posts[1],
                                        ByAuthorTranslation,
                                        culture,
                                        dateNow,
                                        customClassnameDict,
                                        customPostUrl
                                    )}
                            </ol>
                        </aside>
                    </div>
                    <div class={wrapperClass}>
                        <aside class="fxs_entriesList">
                            <ol>
                                {posts &&
                                    this.renderItem(
                                        posts[2],
                                        ByAuthorTranslation,
                                        culture,
                                        dateNow,
                                        customClassnameDict,
                                        customPostUrl
                                    )}
                                {posts &&
                                    this.renderItem(
                                        posts[3],
                                        ByAuthorTranslation,
                                        culture,
                                        dateNow,
                                        customClassnameDict,
                                        customPostUrl
                                    )}
                            </ol>
                        </aside>
                    </div>
                </div>
            </div>
        ) : view === RELATED_NEWS_VIEW.View_Mobile ? (
            <aside class={`fxs_entriesList ${wrapperClass}`}>
                <h3 className={`${customClassnameDict['fxs_subtitle'] || ' fxs_headline_small'}`}>{RelatedNewsTranslation}</h3>
                <ol>
                    {posts &&
                        this.renderItem(
                            posts[0],
                            ByAuthorTranslation,
                            culture,
                            dateNow,
                            customClassnameDict,
                            customPostUrl
                        )}
                    {posts &&
                        this.renderItem(
                            posts[1],
                            ByAuthorTranslation,
                            culture,
                            dateNow,
                            customClassnameDict,
                            customPostUrl
                        )}
                </ol>
            </aside>
        ) : (
            <aside class="fxs_entriesList">
                <h3 className={`${customClassnameDict['fxs_subtitle'] || ' fxs_headline_small'}`}>{RelatedNewsTranslation}</h3>
                <ol>
                    {
                    posts && posts.map(
                        (item) =>
                            this.renderItem(item, ByAuthorTranslation, culture, dateNow, customClassnameDict, customPostUrl),
                        ByAuthorTranslation
                    )}
                </ol>
            </aside>
        );
    }

    renderViewWrapper(view, wrapperClass, children) {
        return view === RELATED_NEWS_VIEW.View_Half ? (
            <div class={wrapperClass}>{children}</div>
        ) : (
            children
        );
    }

    render({
        posts,
        view,
        wrapperClass,
        isFetching,
        fetchError,
        RelatedNewsTranslation,
        ByAuthorTranslation,
        ErrorTranslation,
        culture,
        customClassnameDict,
        customPostUrl
    }) {
        return isFetching
            ? this.renderViewWrapper(
                  view,
                  wrapperClass,
                  this.renderFetching(
                      view,
                      wrapperClass,
                      RelatedNewsTranslation
                  )
              )
            : fetchError
            ? this.renderViewWrapper(
                  view,
                  wrapperClass,
                  this.renderError(
                      view,
                      ErrorTranslation,
                      wrapperClass,
                      RelatedNewsTranslation
                  )
              )
            : this.renderNews(
                  view,
                  wrapperClass,
                  posts,
                  RelatedNewsTranslation,
                  ByAuthorTranslation,
                  culture,
                  customClassnameDict,
                  customPostUrl
              );
    }
}
export default CalendarPosts;
